export type OneClickQRESetItemKind =
  | 'standard'
  | 'custom'
  | 'intake'
  | 'consent'
  | 'pampTodo';

export interface OneClickQRESetItem {
  kind: OneClickQRESetItemKind;
  id: string;
  label: string;
}

export interface OneClickQRESet {
  id: string;
  name: string;
  createdByStaffId: string;
  items: OneClickQRESetItem[];
}

export interface OneClickQRESetNameValidation {
  valid: boolean;
  trimmedName: string;
  errorKey: string;
}

export interface OneClickQRESetResolveResult {
  availableItems: OneClickQRESetItem[];
  missingItems: OneClickQRESetItem[];
}

export const ONE_CLICK_QRE_SETS_EXTRA_CONFIG_KEY = 'oneClickQRESets';
export const MAX_ONE_CLICK_QRE_SETS_PER_CLINIC = 5;
export const MAX_ONE_CLICK_QRE_SET_NAME_LENGTH = 30;
export const MIN_ONE_CLICK_QRE_SET_ITEM_COUNT = 2;
